import { useState } from 'react'
import { useIntl } from 'react-intl'
import styles from './FurnitureViewer.module.css'

/**
 * Small dismissible notice shown when the viewer drops into static mode on a
 * weak/struggling device. Explains why rotation and door animations are off.
 */
export function StaticModeHint() {
  const intl = useIntl()
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  return (
    <div className={styles.staticHint} role="status">
      <span>
        {intl.formatMessage({
          id: 'viewer.staticMode.hint',
          defaultMessage:
            'Interactivitate redusă pentru performanță pe acest dispozitiv.',
        })}
      </span>
      <button
        type="button"
        className={styles.staticHintClose}
        aria-label={intl.formatMessage({
          id: 'viewer.staticMode.dismiss',
          defaultMessage: 'Închide',
        })}
        onClick={() => setDismissed(true)}
      >
        ×
      </button>
    </div>
  )
}
